import React from 'react';
import { ShoppingCartIcon, CogIcon, PercentIcon, GaugeIcon } from 'lucide-react';
export function KPIRow() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-110">
      <KPICard title="Netto salgspris" value="198.500 kr" description="Efter alle rabatter + inkl. salgsfragt" icon={<ShoppingCartIcon className="text-blue-500" size={24} data-id="element-112" />} data-id="element-111" />
      <KPICard title="Total cost" value="151.200 kr" description="Materialer + arbejdsløn + øvrigt + fragt-cost" icon={<CogIcon className="text-gray-500" size={24} data-id="element-114" />} data-id="element-113" />
      <KPICard title="Rabatter i alt" value="23.400 kr" description="12,45%" icon={<PercentIcon className="text-purple-500" size={24} data-id="element-116" />} chips={[{
      label: 'Årsrabat 5% (11.000 kr)'
    }, {
      label: 'Fast rabat (5.400 kr)'
    }, {
      label: 'Kategorirabat (7.000 kr)'
    }]} data-id="element-115" />
      <KPICard title="Endelig margin" value="47.300 kr" description="23,84%" icon={<GaugeIcon className="text-amber-500" size={24} data-id="element-118" />} gauge={{
      value: 23.84,
      min: 20,
      target: 28,
      color: 'amber' // red, amber, green based on value
    }} data-id="element-117" />
    </div>;
}
interface KPICardProps {
  title: string;
  value: string;
  description: string;
  icon: React.ReactNode;
  chips?: {
    label: string;
  }[];
  gauge?: {
    value: number;
    min: number;
    target: number;
    color: 'red' | 'amber' | 'green';
  };
}
function KPICard({
  title,
  value,
  description,
  icon,
  chips,
  gauge
}: KPICardProps) {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-119">
      <div className="flex justify-between items-start" data-id="element-120">
        <h3 className="text-gray-500 font-medium" data-id="element-121">{title}</h3>
        {icon}
      </div>
      <div className="mt-4" data-id="element-122">
        <p className="text-2xl font-bold text-gray-800" data-id="element-123">{value}</p>
        <p className="text-sm text-gray-500" data-id="element-124">{description}</p>
      </div>
      {chips && <div className="mt-4 flex flex-wrap gap-1.5" data-id="element-125">
          {chips.map((chip, index) => <span key={index} className="inline-block px-2 py-1 bg-gray-100 text-xs text-gray-700 rounded-full" data-id="element-126">
              {chip.label}
            </span>)}
        </div>}
      {gauge && <div className="mt-4 flex items-center" data-id="element-127">
          <div className="relative w-12 h-12" data-id="element-128">
            <svg className="w-12 h-12" viewBox="0 0 36 36" data-id="element-129">
              <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#e5e7eb" strokeWidth="3" strokeDasharray="100, 100" data-id="element-130" />
              <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke={gauge.color === 'red' ? '#ef4444' : gauge.color === 'amber' ? '#f59e0b' : '#22c55e'} strokeWidth="3" strokeDasharray={`${gauge.value * 100 / 40}, 100`} data-id="element-131" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center text-xs font-semibold" data-id="element-132">
              {gauge.value}%
            </div>
          </div>
          <div className="ml-3 text-xs" data-id="element-133">
            <div className="flex items-center gap-1" data-id="element-134">
              <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-135"></span>
              <span data-id="element-136">Min. {gauge.min}%</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-137">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-138"></span>
              <span data-id="element-139">Mål {gauge.target}%</span>
            </div>
          </div>
        </div>}
    </div>;
}